<template>
  <div class="quicksearch__dropdown">
    <a-spinner
      v-if="inProgress"
      :size="30"
      :stroke="5"
      disable-transition
      class="quicksearch__spinner"
    />
    <div v-else-if="items.length" class="quicksearch__results">
      <ul class="quicksearch__list">
        <li
          v-for="item in items"
          :key="item.Slug"
          class="quicksearch__list-item text-body"
        >
          <a-link
            :to="settings.generateItemUrl(item)"
            :trailing-slash="settings.isItemUrlWithTrailingSlash(item)"
            @click="onBlur"
            >{{ item.Name }}</a-link
          >
        </li>
      </ul>
      <a-button
        v-if="!hideResultButton"
        class="quicksearch__btn"
        @click="settings.viewAllResultsClickHandler"
      >
        View all results
      </a-button>
    </div>
    <div v-else class="quicksearch__no-results text-caption-legacy">
      No results found
    </div>
  </div>
</template>

<script>
import ASpinner from 'shared/ASpinner'
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'QuickSearchResults',
  components: { ASpinner },
  props: {
    items: propValidator([PROP_TYPES.ARRAY]),
    settings: propValidator([PROP_TYPES.OBJECT]),
    inProgress: propValidator([PROP_TYPES.BOOLEAN]),
    hideResultButton: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  methods: {
    onBlur() {
      this.$emit('blur')
    }
  }
}
</script>

<style lang="scss" scoped>
.quicksearch__dropdown {
  position: absolute;
  top: 58px;
  left: 0;
  width: 100%;
  min-height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $c--gray-soft;
  border-radius: 4px;
  box-shadow: 0px 8px 4px 0px rgba($c--black, 0.05),
    0px 16px 24px 0px rgba($c--black, 0.05);
  background: $c--white;
  z-index: 1;

  .quicksearch__results {
    width: 100%;
  }

  .quicksearch__list-item {
    padding: 12px;
    border-bottom: 1px solid $c--gray-soft;

    & > * {
      display: inline-block;
      width: 100%;
    }

    &:last-child {
      border: none;
    }
  }

  .quicksearch__btn {
    width: 100%;
    border-radius: 0 0 4px 4px;

    @include mobile {
      font-size: 14px;
    }
  }

  .quicksearch__no-results {
    text-align: center;
    color: $c--main;
  }
}
</style>
